import useAPIQuery from '../api/useAPIQuery';
import { JobPostingId } from '../types';
import usePermissionCheckerQuery from './usePermissionCheckerQuery';

interface UseCanManageJobPostingProps {
  jobPostingId?: ReturnType<typeof JobPostingId>;
}

const useCanManageJobPosting = ({ jobPostingId }: UseCanManageJobPostingProps) => {
  const accessToAllJobPostings = usePermissionCheckerQuery(['view_all_vacancies']);

  const user = useAPIQuery('/users/me/', {
    enabled: accessToAllJobPostings.isSuccess && !accessToAllJobPostings.data,
  });

  const currentRecruiter = useAPIQuery(
    [
      `/recruiters/`,
      {
        params: {
          user_id: user.data?.id,
          job_posting_id: jobPostingId,
        },
      },
    ],
    {
      enabled: Boolean(user.data?.id && jobPostingId && !user.data.is_staff),
      select(data) {
        if (data.results.length > 0) {
          return data.results[0];
        }
      },
    }
  );

  const canManage = Boolean(
    user.data?.is_staff ||
      accessToAllJobPostings.data ||
      (currentRecruiter.data && currentRecruiter.data.type !== 'OBSERVER')
  );

  return canManage;
};

export default useCanManageJobPosting;
